import {openAIConfig} from "../../firebase/client-app";
import {Configuration, OpenAIApi} from "openai";
import _ from "lodash";

const configuration = new Configuration({
    apiKey: openAIConfig.apiKey
});

const openai = new OpenAIApi(configuration);

export {
    generateContent,
    generateJsonContent,
    generateJsonFormatContent,
    processContentToJson,
}

const generateContent = async (messages?) => {
    const completion = await openai.createChatCompletion({
        model: "gpt-4-1106-preview",
        messages: messages,
    });

    return completion.data.choices[0].message;
}

const generateJsonFormatContent = async (messages?) => {
    const completion = await openai.createChatCompletion({
        model: "gpt-4-1106-preview",
        response_format: {type: "json_object"},
        messages: messages,
    } as any);

    const outputMessage = completion.data.choices[0].message;
    return processContentToJson(outputMessage?.content);
}

const generateJsonContent = async (messages?) => {
    const completion = await openai.createChatCompletion({
        model: "gpt-4-1106-preview",
        messages: messages,
    });

    const outputMessage = completion.data.choices[0].message;
    return processContentToJson(outputMessage?.content);
}

const processContentToJson = async (content) => {
    let outputJson;

    try {
        outputJson = JSON.parse(content);
    } catch (e) {
        let tempContent;
        if (content.indexOf('```json') !== -1) {
            tempContent = content.split('```json')[1];
            tempContent = tempContent.split('```')[0];
            outputJson = JSON.parse(cleanupJsonText(tempContent));
        } else if (content.indexOf('```JSON') !== -1) {
            tempContent = content.split('```JSON')[1];
            tempContent = tempContent.split('```')[0];
            outputJson = JSON.parse(cleanupJsonText(tempContent));
        } else if (content.indexOf('```') !== -1) {
            tempContent = content.split('```')[1];
            outputJson = JSON.parse(cleanupJsonText(tempContent));
        } else if (content.indexOf('},\\n]') !== -1) {
            tempContent = _.replace(content, /},\n]/g, '}\\n]');
            tempContent = _.join(_.split(tempContent, '}\\n]')[0], '}\\n]');
            outputJson = JSON.parse(cleanupJsonText(tempContent));
        } else {
            outputJson = content;
            console.log('Error - NOT MD Content', content);
        }
    }

    return outputJson;
}

const cleanupJsonText = (content) => {
    return _.replace(content, /,}/g, '}');
}
